import { SimplifyModifier } from "three/addons/modifiers/SimplifyModifier.js";
import * as THREE from "three";
import { prepareConvex } from "./Mesh";
import { createSpatialGrid } from "./CEPH";

/**
 * @param {int} object the object to simplify
 * @param {int} simplifingPercentage int from 0 to 100
 * @returns a clone of the object with geometry faces number = object faces count * simplifingPercentage
 */
export function CreateLowResolutionObject(object, simplifingPercentage) {
  let startTime = Date.now();

  const newGeom = new THREE.BufferGeometry();

  newGeom.setAttribute(
    "position",
    new THREE.BufferAttribute(object.geometry.attributes.position.array, 3),
  );

  const modifier = new SimplifyModifier();
  const simplifiedObject = new THREE.Mesh(
    cloneGeometryWithoutAttributes(object.geometry),
  );
  // simplifiedObject.geometry.boundingBox = object.geometry.boundingBox;
  // simplifiedObject.geometry.boundingSphere = object.geometry.boundingSphere;
  // simplifiedObject.geometry.;
  // simplifiedObject.material = simplifiedObject.material.clone();

  simplifiedObject.material.side = THREE.DoubleSide;
  // simplifiedObject.material.flatShading = true;
  // simplifiedObject.material.wireframe = true;

  const count = Math.floor(
    (simplifiedObject.geometry.attributes.position.count *
      simplifingPercentage) /
      100,
  );

  simplifiedObject.geometry = modifier.modify(simplifiedObject.geometry, count);
  if (!simplifiedObject.geometry.attributes.position.count) {
    CreateLowResolutionObject(object, simplifingPercentage - 5);
    return;
  }
  simplifiedObject.name = object.name + "_simplified";
  const lowResolutionGroup = new THREE.Group();
  lowResolutionGroup.name = "lowResolutionGroup";
  lowResolutionGroup.attach(simplifiedObject);
  lowResolutionGroup.visible = false;
  object.add(lowResolutionGroup);

  createSpatialGrid(simplifiedObject, { x: 4, y: 10, z: 4 });
  createSpatialGrid(object);

  // object.add(prepareConvex(simplifiedObject));

  // console.log("end Time", Date.now() - startTime, simplifiedObject.name);
}

/**
 * @param {int} gum the gum to simplify its teeth children
 * @param {int} simplifingPercentage int from 0 to 100
 * @returns a clone of the object with geometry faces number = object faces count * simplifingPercentage
 */
export function CreateLowResolutionTeethFromGum(gum, simplifingPercentage) {
  const startTime = Date.now();

  gum.children.forEach(tooth => {
    CreateLowResolutionObject(tooth, simplifingPercentage);
  });
  console.log("end Time", Date.now() - startTime);
}

function cloneGeometryWithoutAttributes(originalGeometry) {
  const newGeometry = new THREE.BufferGeometry();

  // Clone position attribute
  if (originalGeometry.attributes.position) {
    newGeometry.setAttribute(
      "position",
      originalGeometry.attributes.position.clone(),
    );
  }

  // Clone index attribute if available
  if (originalGeometry.index) {
    newGeometry.setIndex(originalGeometry.index.clone());
  }

  // Optional: Copy bounding information if present
  if (originalGeometry.boundingBox) {
    newGeometry.boundingBox = originalGeometry.boundingBox.clone();
  }

  if (originalGeometry.boundingSphere) {
    newGeometry.boundingSphere = originalGeometry.boundingSphere.clone();
  }

  return newGeometry;
}
